import FormChangeSpy from 'components/FormChangeSpy'
import { useMemo } from 'react'
import debounce from 'lodash/debounce'

type Props = {
  storageKey: string
}

export default function FormValuesRecorder<T extends object>({
  storageKey
}: Props) {
  const saveWithDebounce = useMemo(
    () =>
      debounce(
        (values: T) => {
          if (typeof sessionStorage === 'undefined') return

          sessionStorage.setItem(storageKey, JSON.stringify(values))
        },
        100,
        { maxWait: 500 }
      ),
    [storageKey]
  )

  return <FormChangeSpy onChange={saveWithDebounce} />
}
